import { useContext, createContext, useMemo } from 'react';

const AnonShareTokenContext = /* @__PURE__ */ createContext(void 0);
const useContextAccessToken = () => {
  const context = useContext(AnonShareTokenContext);
  return context?.accessToken;
};
const useContextShareToken = () => {
  const context = useContext(AnonShareTokenContext);
  return context;
};
const useContextShareTokenExtraPermissions = () => {
  const context = useContext(AnonShareTokenContext);
  return useMemo(() => ({
    disabledDownload: context && "allowDownload" in context && !context.allowDownload,
    disabledCopy: context && "allowCopy" in context && !context.allowCopy
  }), [
    context
  ]);
};

export { AnonShareTokenContext, useContextAccessToken, useContextShareToken, useContextShareTokenExtraPermissions };
//# sourceMappingURL=AnonShareTokenContext.js.map
